import { millisecondsToTime } from '../../../utils/helpers/time';
import { API_PLAY_TYPE_KEYS } from '../../../utils/constants/api';
import {
  getQBPressuredNote,
  getPassNote,
  getInterceptionNote,
  getHandoffNote,
  getQBRunNote,
  getTackledNote,
  getScoreChangeNote,
} from '../GamePlayByPlay/PlayByPlay.EventDescription';

// Shared by every Game Overview table that lists plays (the Play by Play
// drive sub-table and Scoring Plays), so the same play reads the same way in
// both.

// Strip the "for X yards..." / "for +N points" suffixes so we just show the
// people involved.
const stripFor = (s) => s.replace(/ for [^;]+/g, '');

// Action note for a play, built from its events. Field goals have no
// pass/run/tackle notes, so they fall back to the scoring event, which still
// gives the kicker's name. Empty string until the events arrive.
export const composePlayDescription = (play, playEvents) => {
  if (!playEvents?.length) return '';
  if (play.type === API_PLAY_TYPE_KEYS.FIELD_GOAL) {
    const note = getScoreChangeNote(playEvents);
    return note ? stripFor(note) : '';
  }
  const notes = [
    getQBPressuredNote(play),
    getPassNote(playEvents),
    getInterceptionNote(playEvents),
    getHandoffNote(play, playEvents),
    getQBRunNote(play, playEvents),
    getTackledNote(playEvents),
  ].filter(Boolean);
  return stripFor(notes.join('; '));
};

export const resolvePenaltyText = (play) => {
  const parts = [];
  if (play.offensePenaltyAccepted) parts.push('Penalty against defense');
  if (play.defensePenaltyAccepted) parts.push('Penalty against offense');
  if (play.penaltyOffset) {
    parts.push('Penalties Offset');
  } else if (play.penaltyYards) {
    const prefix = play.penaltyYards > 0 ? '+' : '';
    parts.push(`${prefix}${play.penaltyYards.toFixed(0)} yds`);
  }
  if (play.penaltyFirstDown) parts.push('New First Down');
  if (play.penaltyDownLoss) parts.push('Down Lost');
  if (play.penalties?.length) {
    parts.push(`[${play.penalties.map((p) => p.type).join('; ')}]`);
  }
  return parts.join(', ');
};

// `overtimePeriod`, when known, numbers the overtime (OT1, OT2); otherwise
// every overtime reads from the quarter alone.
const playQuarterLabel = (q, overtimePeriod = null) => {
  if (q == null) return '';
  if (q <= 4) return `Q${q}`;
  if (overtimePeriod != null) return `OT${overtimePeriod}`;
  const extra = q - 4;
  return extra > 1 ? `OT${extra}` : 'OT';
};

export const formatPlayClock = (play) => {
  const label = playQuarterLabel(play.quarter, play.overtimePeriod);
  if (play.quarterClockRemaining == null) return label;
  return `${label}, ${millisecondsToTime(play.quarterClockRemaining)}`;
};
